import AccountCircle from "@mui/icons-material/AccountCircle";
import Key from "@mui/icons-material/Key";
import ReceiptLong from "@mui/icons-material/ReceiptLong";

import { NavigationListItem } from "@/components/molecules/NavigationList/types";
import { ProfileMessages } from "@/messages/profile/profile.messages";

import ROUTE_URLS from "./route-urls";

type NavigationProps = {
  messages: ProfileMessages;
};

export type ProfileNavigationIds = "profile" | "permissions" | "change-password";

export const profileNavigationItems = ({
  messages,
}: NavigationProps): NavigationListItem<ProfileNavigationIds>[] => [
  {
    _id: "profile",
    title: messages.profileLabel,
    icon: <AccountCircle />,
    selectedIcon: <AccountCircle color="primary" />,
    href: ROUTE_URLS.profile,
  },
  {
    _id: "permissions",
    title: messages.permissionsLabel,
    icon: <ReceiptLong />,
    selectedIcon: <ReceiptLong color="primary" />,
    href: ROUTE_URLS.permissions,
  },
  {
    _id: "change-password",
    title: messages.changePasswordLabel,
    icon: <Key />,
    selectedIcon: <Key color="primary" />,
    href: ROUTE_URLS.changePassword,
  },
];
